import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { isLeasedCategory } from '../../../utils/helpers';
import AgencyFilterResultsBlock from './AgencyFilterResultsBlock';

const AgencyFilterResults = ({
  agencyId,
  categories,
  activeCategoryId,
  activeLeasedCategory,
  onClickItem,
  setActiveLeasedCategory
}) => {
  const { t } = useTranslation();
  const getTitle = category => {
    let title;
    if (activeCategoryId === 'all' && isLeasedCategory(category.id)) {
      title = t(`pages.agency.${category.id}`);
    } else if (isLeasedCategory(activeCategoryId)) {
      title = t(`pages.agency.filter.${activeCategoryId}`, {
        id: t(`pages.agency.filter.id_${category.id}`)
      });
    } else if (isLeasedCategory(category.id)) {
      title = t(`pages.agency.filter.${category.id}`, {
        id: t(`pages.agency.filter.id_${activeCategoryId}`)
      });
    } else if (category.title) {
      // eslint-disable-next-line  prefer-destructuring
      title = category.title;
    }

    return title;
  };

  return (
    <div className="agency-filter__results">
      {categories.map(category => {
        if (activeCategoryId === 'all') {
          return (
            <AgencyFilterResultsBlock
              key={category.id}
              title={getTitle(category)}
              category={category}
              agencyId={agencyId}
              activeCategoryId={activeCategoryId}
              isLeased={false}
              limit={4}
              onClickItem={onClickItem}
            />
          );
        }
        if (
          isLeasedCategory(activeCategoryId) &&
          !isLeasedCategory(category.id)
        ) {
          return (
            <AgencyFilterResultsBlock
              key={category.id}
              title={getTitle(category)}
              category={category}
              agencyId={agencyId}
              activeCategoryId={activeCategoryId}
              limit={activeLeasedCategory.length > 1 ? 4 : 20}
              isLeased={true}
              onClickItem={onClickItem}
              setActiveLeasedCategory={setActiveLeasedCategory}
            />
          );
        }
        if (
          activeLeasedCategory.includes(category.id) &&
          !isLeasedCategory(activeCategoryId) &&
          isLeasedCategory(category.id)
        ) {
          return (
            <AgencyFilterResultsBlock
              key={category.id}
              title={getTitle(category)}
              category={{ id: activeCategoryId }}
              agencyId={agencyId}
              activeCategoryId={category.id}
              limit={activeLeasedCategory.length > 1 ? 4 : 20}
              onClickItem={onClickItem}
              isLeased={true}
              setActiveLeasedCategory={setActiveLeasedCategory}
            />
          );
        }

        return null;
      })}
    </div>
  );
};

AgencyFilterResults.displayName = `AgencyFilterResults`;

AgencyFilterResults.propTypes = {
  activeLeasedCategory: PropTypes.array,
  categories: PropTypes.array,
  agencyId: PropTypes.string,
  activeCategoryId: PropTypes.string,
  onClickItem: PropTypes.func,
  setActiveLeasedCategory: PropTypes.func
};

export default AgencyFilterResults;
